import React, { useEffect, useState } from 'react'
import { Header, Segment, } from 'semantic-ui-react'
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder'
import moment from 'moment'

import vendorActionButton from './vendorActionButton';
import AgGridTable from '../../agGridComponent/agGridTable';
import Axios from 'axios';
import APP_CONSTANTS from '../../../config/constants';
import { DATE_DDMMYYYY, FEATURES } from '../../../utils/constants'

function VendorTable(props) {
    const [vendors, setvendors] = useState([])
    const [isLoaded, setisLoaded] = useState(false)
    const [isUpdated, setisUpdated] = useState(false)
    useEffect(() => {
        getData()
    }, [isUpdated])

    let getData = () => {
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let data = JSON.stringify
            ({
                customerNumber: customerNo,
                userId: userId,
            })
        // console.log(APP_CONSTANTS)
        Axios.post(`${process.env.REACT_APP_SCCT_URL}/masters/transporterMaster`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": token,
                "Access-Control-Allow-Origin": "*"
            }
        }).then((response => {
            // console.log(response.data.data)
            setvendors(response.data.resultSet)
            setisLoaded(true)
        }))
            .catch(error => console.log(error))

        // ReadAxios({ url: 'vendor/vendors' }).then((result) => {
        //     setvendors(result)
        //     setisLoaded(true)
        // })
    }
    let getUpdate = (data) => {
        if (data) {
            setisUpdated(!isUpdated)
        }
    }
    if (vendors.length === 0 && isLoaded === false) {
        return (
            <LoadingPlaceholder />
        )
    } else if (vendors.length === 0) {
        return (
            <Segment className="m-2">
                <center> <Header>NO Record(s) Found</Header></center>
            </Segment>
        )
    } else {

        let columnDefs = [
            { headerName: 'Vendor Code', field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Vendor Name', field: 'name', tooltipField: 'name', enableRowGroup: true, enablePivot: true, filter: true },
            // { headerName: 'Vendor Type', field: 'type', tooltipField: 'type', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Contact Person', field: 'person', tooltipField: 'person', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Mobile No.', field: 'phone', tooltipField: 'phone', enableRowGroup: true, enablePivot: true, filter: true },
            // { headerName: 'Email Id', field: 'eid', tooltipField: 'eid', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created By', field: 'cby', tooltipField: 'uby', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Created Date', field: 'cdate', tooltipField: 'uby', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Updated By', field: 'uby', tooltipField: 'uby', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Updated Date', field: 'udate', tooltipField: 'udate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'vendor Type', field: 'vendorType', tooltipField: 'vendorType', filter: false },
            { headerName: 'Edit / Delete', field: 'edit', cellRenderer: 'actionRenderer' },
        ]
        let rowData = []
        vendors.map((object, i) => {
            let temp = {}
            temp.code = object.transporterCode.toUpperCase()
            temp.name = object.transporterName
            temp.type = object.vendorOwnershipType
            temp.person = object.transporterContactPerson
            temp.phone = object.transporterContactPersonNumber
            temp.id = object.transporterMasterId
            temp.eid = object.transporterEmail
            temp.cby = object.createdBy
            temp.cdate = object.createdOn ? moment(object.createdOn).format(DATE_DDMMYYYY) : null
            temp.uby = object.updatedBy
            temp.udate = object.updatedOn ? moment(object.updatedOn).format(DATE_DDMMYYYY) : null
            temp.customerNo = object.customerNo
            temp.vendorTypeId = object.vendorTypeId || 0
            temp.vendorType = object.vendorType
            rowData[i] = temp
        })
        return (
            <React.Fragment >
                <AgGridTable
                    columnDefs={columnDefs}
                    rowData={rowData}
                    searchValue={props.searchValue}
                    actionButton={vendorActionButton}
                    reload={getUpdate}
                    link="/add-vendor"
                    hiddenNew={false}
                    hiddenNewPopupBtn={true}
                    titleBarTitle="Vendors"
                    handleSearch={props.handleSearch}
                    hiddenImportPopupBtn={true}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                />
            </React.Fragment>
        )
    }

}

export default VendorTable
